import PartImg from 'components/Common/PartImg'
import GeometryViewerModal from 'pages/Offer/Modals/GeometryViewerModal'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'

/**
 * @param {{
 *   id?: string
 *   geometryData?: object
 *   height?: number
 *   width?: number
 *   hideData?: boolean
 * }} props
 */
const PartThumbnail = ({ geometryData, id, hideData, height, width }) => {

	const partId = geometryData?.partId
	const partFiles = useSelector(state => (
		/** @type {StoreState} */(state)
		.CloudStorage.partsFiles?.parts?.find(p => parseInt(p.id) === partId)?.fileLinks
	))
	
	const [isGeometryViewerModalOpen, setIsGeometryViewerModalOpen] = useState(false)

	return (
		<div
			id={id ?? `part_thumbnail_${partId}`}
			className='d-flex justify-content-start cursor-pointer'
			onClick={() => setIsGeometryViewerModalOpen(true)}
		>
			<GeometryViewerModal
				isGeometryViewerModalOpen={isGeometryViewerModalOpen}
				closeGeometryViewerModal={() => setIsGeometryViewerModalOpen(false)}
				geometryViewerData={{
					...geometryData,
					modelSrc: partFiles?.stlModel ?? partFiles?.objModel,
				}}
				stepModelSrc={partFiles?.stepModel}
				hideData={hideData}
			/>
			<PartImg
				partId={partId}
				height={height ?? 100}
				width={width ?? 75}
			/>
		</div>
	)
}

PartThumbnail.propTypes = {
	id: PropTypes.string,
	geometryData: PropTypes.object,
	height: PropTypes.number,
	width: PropTypes.number,
	hideData: PropTypes.bool,
}

export default PartThumbnail
